import type { SpaceSettingDTO } from '@next-space/fe-api-idl';
import { useCurrentSpace, useSpace } from './use-current-space';
import { isTeamProSpace } from './use-is-pro-space';

export function useSpaceSecurityState<
  K extends keyof Pick<
    SpaceSettingDTO,
    | 'abandonedExport'
    | 'abandonedGuest'
    | 'abandonedPublicShare'
    | 'openWatermark'
    | 'openImageWatermark'
    | 'imageWatermarkText'
  >
>(state: K, spaceId?: string) {
  const space = useSpace(spaceId);
  const currentSpace = useCurrentSpace();
  if (space.uuid) {
    if (!isTeamProSpace(space.planType)) return false;
    // @ts-ignore 不要动这里的代码,由于访客拉到的空间信息字段并不是在setting里的，这里做下兼容处理
    return space?.setting?.[state] || space[state];
  }
  if (currentSpace.uuid) {
    if (!isTeamProSpace(currentSpace.planType)) return false;
    // @ts-ignore 不要动这里的代码,由于访客拉到的空间信息字段并不是在setting里的，这里做下兼容处理
    return currentSpace?.setting?.[state] || currentSpace[state];
  }
}
